import { GameMap } from "../games";

// Titles and sp/dm flags come from the re-release's own id1/pak0.pak mapdb.json,
// resolved through localization/loc_english.txt.
export default [
  {
    name: 'start',
    title: 'The Gateway',
    collection: ''
  },
  {
    name: 'hub',
    title: 'The Machine',
    collection: ''
  },
  {
    name: 'mge1m1',
    title: 'The Pain Drain',
    collection: 'Episode 1'
  },
  {
    name: 'mge1m2',
    title: 'The Wishing Well',
    collection: 'Episode 1'
  },
  {
    name: 'mge1m3',
    title: 'Sandy\'s Room',
    collection: 'Episode 1'
  },
  {
    name: 'mge2m1',
    title: 'Acid Sanctuary',
    collection: 'Episode 2'
  },
  {
    name: 'mge2m2',
    title: 'Fading Embers',
    collection: 'Episode 2'
  },
  {
    name: 'mge3m1',
    title: 'Down the Waste',
    collection: 'Episode 3'
  },
  {
    name: 'mge3m2',
    title: 'Hell or Dark Water',
    collection: 'Episode 3'
  },
  {
    name: 'mge4m1',
    title: 'Grave Machine',
    collection: 'Episode 4'
  },
  {
    name: 'mge4m2',
    title: 'A Grave Mistake',
    collection: 'Episode 4'
  },
  {
    name: 'mge5m1',
    title: 'Nazard Terminal',
    collection: 'Episode 5'
  },
  {
    name: 'mge5m2',
    title: 'Too Deep, Too Greedy',
    collection: 'Episode 5'
  },
  {
    name: 'mgend',
    title: 'Chthon\'s Vengeance',
    collection: 'Finale'
  },
  {
    name: 'mgdm1',
    title: 'Art of the Condemned',
    collection: 'Deathmatch',
    sp: false
  },
  {
    name: 'mgdm2',
    title: 'The Bad Space',
    collection: 'Deathmatch',
    sp: false
  },
  {
    name: 'mgdm3',
    title: 'The Mustard Factory',
    collection: 'Deathmatch',
    sp: false
  },
  {
    name: 'mgdm4',
    title: 'The Boiler',
    collection: 'Deathmatch',
    sp: false
  },
  {
    name: 'horde1',
    title: 'Tower of the Apprentice',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde2',
    title: 'Frozen Court',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde3',
    title: 'The Foundry',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde4',
    title: 'The Hunt',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde5',
    title: 'Relic',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde6',
    title: 'The Trial',
    collection: 'Horde',
    sp: false
  },
  {
    name: 'horde7',
    title: 'The Tower',
    collection: 'Horde',
    sp: false
  },
] as GameMap[]
